module.exports = require("./lib/_stream_writable.js")



//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/readable-stream/writable.js
// module id = ../../../../readable-stream/writable.js
// module chunks = 3